
import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { AIDocument, AIDocumentService, DocumentHashOptions, DocumentHashResponse, FileUrlOptions } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { randomBytes } from "crypto";
import { randomColor } from "../../../common";


export interface AIDocumentOptions extends ControllerOptions<AIDocument> {
    tags?: string[];
    url?: string;
}

export const initAIDocument = () => {
    let item: AIDocument = {
        fileName: "",
        name: "",
        createdBy: "",
        color: randomColor()
    }
    return item;
}

export const createAIDocument = (item: Partial<AIDocument>): AIDocument => {
    return {
        id: item.id ?? "",
        name: item.name ?? "",
        fileName: item.fileName ?? "",
        createdBy: item.createdBy ?? "",
        tags: item.tags ?? [],
        color: randomColor()

    }
}




export class ClientAIDocumentService extends BaseClientService implements DataController<AIDocument> {

    private _service: AIDocumentService;


    constructor() {
        super();
        this._service = new AIDocumentService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }

    public async get(options: AIDocumentOptions): Promise<ResultData<AIDocument>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: AIDocumentOptions): Promise<ResultData<AIDocument>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: AIDocumentOptions): Promise<AIDocument | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: AIDocumentOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: AIDocumentOptions): Promise<AIDocument | AIDocument[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: AIDocumentOptions): Promise<AIDocument | AIDocument[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }



    public async import(options: AIDocumentOptions): Promise<any> {
        if (options.file && options.item) {
            return await this._service.import(options.file, this.token, options.item);
        }
    }

    public async importUrl(options: AIDocumentOptions): Promise<any> {
        if (options.url && options.item) {
            let importOptions: FileUrlOptions = {
                item: options.item,
                url: options.url
            }
            return await this._service.importUrl(importOptions, this.token);
        }
    }

    public async download(options: AIDocumentOptions): Promise<any> {
        if (options.id) {
            return await this._service.download(options.id, this.token);
        }
        throw new Error("Document ID is required for download.");
    }

    public async getByHash(hash: string): Promise<DocumentHashResponse> {

        if (hash) {
            let options: DocumentHashOptions = {
                hash: hash
            }
            return await this._service.findByHash(options, this.token);
        }
        throw new Error("Hash is required to find document.");
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult | null> {
        return await this._service.validateName(name, this.token, id, "")
    }

}